import { useMemo } from 'react';

import { LOCATION_ATTRIBUTE_VALUE } from '../../../retailer-network-location-update-page/retailer-network-location-update-page.types';
import { LocationSectionBaseParams } from '../../retailer-network-location-details-page.types';

export type LocationScheduleReturns = {
  data: {
    attributes: string[];
  };
};

export const useLocationAttributes = (
  params: LocationSectionBaseParams,
): LocationScheduleReturns => {
  const { location } = params;

  const attributes = useMemo(
    () =>
      location?.attributes
        .filter((attribute) => attribute.value === LOCATION_ATTRIBUTE_VALUE.YES)
        .map((attribute) => attribute.name) || [],
    [location?.attributes],
  );

  return useMemo(
    () => ({
      data: {
        attributes,
      },
    }),
    [attributes],
  );
};
